import React from 'react'
import { Dropdown, DropdownMenu, DropdownToggle } from 'reactstrap'
import PropTypes from 'prop-types'
import styled from 'styled-components'

const propTypes = {
  selected: PropTypes.number,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.number,
  })),
  renderOption: PropTypes.func.isRequired,
  onSelect: PropTypes.func.isRequired,
}

class SelectPicker extends React.Component {
  state = {
    opened: false
  }

  toggle = () => {
    this.setState(prevState => ({
      opened: !prevState.opened
    }))
  }

  handleChange = (option) => {
    this.props.onSelect(option)
    this.toggle()
  }

  render() {
    const { opened } = this.state
    const { options, selected, renderOption } = this.props

    const hasOptions = options.length > 0

    return (
      <Dropdown isOpen={opened} toggle={this.toggle}>
        <DropdownToggle tag="div">
          <DropdownContainer>
            {hasOptions && <div>{renderOption(options.find(option => option.id === selected))}</div>}
            <DropdownIcon className={`fa fa-caret-${opened ? 'up' : 'down'}`}/>
          </DropdownContainer>
        </DropdownToggle>
        <DropdownMenu>
          {
            hasOptions && options.map((option, i) => (
                <Item
                  key={option.id || i}
                  onClick={() => this.handleChange(option)}
                >
                  {renderOption(option)}
                </Item>
              )
            )}
        </DropdownMenu>
      </Dropdown>
    )
  }
}

const Item = styled.div`
  padding: .3rem;
  cursor: default;
  &:hover {
    background: ${({ theme }) => theme.lightGray};
  }
`

const DropdownIcon = styled.i`
  margin-left: 10px;
`

const DropdownContainer = styled.div`
  background: ${({ theme }) => theme.lightGray};
  padding: .2rem .5rem;
  color: ${({ theme }) => theme.black};
  margin: 1rem 0;
  border-radius: 3px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  cursor: default;
  
  @media all and (max-width: 990px) {
    padding: .5rem;
  }
`

SelectPicker.propTypes = propTypes

export const IconOption = ({ icon, value }) => {
  return (
    <React.Fragment>
      <Icon src={icon}/>
      <Value>{value}</Value>
    </React.Fragment>
  )
}

const Icon = styled.img`
  width: 24px;
  margin-right: 5px;
`

const Value = styled.span`
  color: ${({ theme }) => theme.black};
`

export default SelectPicker
